import { render, staticRenderFns } from "./ContactPhones.vue?vue&type=template&id=0dfd4e4d"
import script from "./ContactPhones.vue?vue&type=script&lang=js"
export * from "./ContactPhones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports